require('../../libs/backbone/backbone.ajaxq.adapter.ts');

var TheModel = Backbone.Model.extend({
	initialize: function(attributes, options) {
        this.bind("error", this.defaultErrorHandler);
    },
	parse: function(response)
	{
		if(!response.data && !response.content)
		{
			return response;
		}
		return response.data;
	},
	defaultErrorHandler: function(model, error) {
	 	document.cookie = "status=" + error.status;
		if (error.status == 401) {
			window.open('./','_self');
		}else if(error.status == 403){
			$.notify(i18n.t("user.not_allowed"), { position:"top center", className: "error"});
			$.ajaxq.abort("DefaultQueue");
			window.open('./','_self');
		}else {
		    var str = "";
            var causes = error.responseJSON.error.causes;

            for(i=0; i<causes.length; i++)
                str += causes[i].message +"\n";

            $.notify(str, { position:"top center", className: "error" });
		}
	},
 	attributeUrl: function (attributeName) {
		return this.urlRoot + '/' + this.get("id") + "/" + attributeName;
	},
	attributeNullUrl: function(attributeName){
		return this.urlRoot+'/null/'+this.get("id")+"/"+attributeName;
	},
	saveAttribute: function (attributeName, value, callback) {
		var self = this;
		var url = value == null ? self.attributeNullUrl(attributeName) : self.attributeUrl(attributeName);
		$.ajaxDefaultQ({
			url: url,
			type: value == null ? 'POST' : 'PUT',
			contentType: 'application/json',
			data: value == null ? JSON.stringify("") : JSON.stringify(value),
			dataType: 'json'

		}).done(function (data) {
			callback(attributeName, value, data.outcome);
		}).fail(function (data) {
			callback(attributeName, value, "NotDone");
		});
	}
});

module.exports = TheModel;